import styled from 'styled-components';

export const ProgressBarWrapper = styled.div`
  background-color: ${({ theme }) =>
    `${theme.palette.commons.background.container}`};
  border-radius: 16px;
  width: 100%;
`;
export const ProgressBarContent = styled.div`
  background-color: ${({ theme }) => `${theme.palette.brand.color}`};
  border-radius: 16px;
  height: 4px;
`;
